import * as Yup from 'yup';

import { Nullable } from '~globals/types';
import { PreferencesTrackingComplaintChannelTypeId } from '~globals/types/enums';
import { AdminCompanySetting } from '~services/admin/companySetting/types';
import { VALIDATIONS_ERROR } from '~constants/index';
import { getComplaintAddress } from '~modules/Config/Preferences/form/complaint';
import {
  validateComplaintEmail,
  validateComplaintPhone,
} from '~modules/Config/Preferences/form/validationSchema';

export const FIELDS_NAME = {
  COMPLAINT_CHANNEL_TYPE: 'complaintChannelType',
  COMPLAINT_EMAIL: 'complaintEmail',
  COMPLAINT_PHONE: 'complaintPhone',
  ZEBRA_MODE_IN_TICKET_PDF: 'zebraModeInTicketPdf',
  INCLUDE_DIE_IN_TICKET_PDF: 'includeDieInTicketPdf',
  ONE_TICKET_BY_ARTICLE: 'oneTicketByArticle',
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInitialValues = (data: Nullable<AdminCompanySetting>) => ({
  [FIELDS_NAME.COMPLAINT_CHANNEL_TYPE]: String(
    data?.complaintChannelTypeId ??
      PreferencesTrackingComplaintChannelTypeId.None,
  ),
  [FIELDS_NAME.COMPLAINT_EMAIL]: getComplaintAddress(
    PreferencesTrackingComplaintChannelTypeId.Email,
    data?.complaintChannelTypeId ?? undefined,
    data?.complaintAddress,
  ),
  [FIELDS_NAME.COMPLAINT_PHONE]: getComplaintAddress(
    PreferencesTrackingComplaintChannelTypeId.Whatsapp,
    data?.complaintChannelTypeId ?? undefined,
    data?.complaintAddress,
  ),
  [FIELDS_NAME.ZEBRA_MODE_IN_TICKET_PDF]: data?.zebraModeInTicketPdf ?? false,
  [FIELDS_NAME.INCLUDE_DIE_IN_TICKET_PDF]: data?.includeDieInTicketPdf ?? true,
  [FIELDS_NAME.ONE_TICKET_BY_ARTICLE]: data?.oneTicketByArticle ?? false,
});

export const validationSchema = Yup.object().shape({
  [FIELDS_NAME.COMPLAINT_CHANNEL_TYPE]: Yup.string().required(
    VALIDATIONS_ERROR.REQUIRED,
  ),
  [FIELDS_NAME.COMPLAINT_EMAIL]: validateComplaintEmail,
  [FIELDS_NAME.COMPLAINT_PHONE]: validateComplaintPhone,
  [FIELDS_NAME.ZEBRA_MODE_IN_TICKET_PDF]: Yup.boolean(),
  [FIELDS_NAME.INCLUDE_DIE_IN_TICKET_PDF]: Yup.boolean(),
  [FIELDS_NAME.ONE_TICKET_BY_ARTICLE]: Yup.boolean(),
});
